import React, { PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import docCookies from '../../services/cookieStorage/cookieStorage';
import * as pathConstants from '../../constants/pathConstants';
//import * as errorMessages from '../../constants/errorMessages';
import * as loginActions from '../../actions/loginActions';

export default function (ComposedComponent) {
  class Authentication extends React.Component {
    constructor(props, context) {
      super(props, context);
    }

    componentWillMount() {
      if (!this.props.authenticated) {
        this.props.actions.loginWithLoginGov()
          .then((response) => {
            if (response.authenticated) {
              let loginDate = +new Date();
              sessionStorage.setItem('lastLogin', loginDate);
              sessionStorage.setItem('cookieName', response.session_name);
              sessionStorage.setItem('onLogin', '1');
              sessionStorage.setItem('helpRedirect', '1');
              docCookies.setItem(response.session_name, response.session_id, null, '/');
            } else {
              const logouturl = window.location.origin+pathConstants.pathToLogout;
              window.location = logouturl;
            }
          }).catch(error => {
            throw (error);
          });
      }
    }

    render() {
      return (<ComposedComponent {...this.props} />);
    }
  }

  Authentication.contextTypes = {
    router: PropTypes.object
  };

  Authentication.propTypes = {
    authenticated: PropTypes.bool.isRequired,
    pathIntended: PropTypes.string.isRequired
  };

  function mapStateToProps(state) {
    return {
      authenticated: state.login[state.login.length - 1].authenticated,
      pathIntended: pathConstants.pathToHome
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      actions: bindActionCreators(loginActions, dispatch)
    };
  }

  return connect(mapStateToProps, mapDispatchToProps)(Authentication);
}



/** WEBPACK FOOTER **
 ** ./src/components/authentication/Authentication.js
 **/